/**
 * Product gallery thumbnail slider: the vertical thumb strip scrolls via
 * up/down arrow buttons (and stays wheel-scrollable). Arrows only render
 * when the strip actually overflows, and hide at either end.
 */
const thumbsGallery = document.querySelector(
  '.single-product div.product .woocommerce-product-gallery'
);

if (thumbsGallery) {
  const whenInitialized = new Promise((resolve) => {
    if (getComputedStyle(thumbsGallery).opacity === '1') {
      resolve();
      return;
    }
    // WC core sets the inline opacity to 1 right after the flexslider boots.
    const observer = new MutationObserver(() => {
      if (thumbsGallery.style.opacity === '1') {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(thumbsGallery, { attributes: true, attributeFilter: ['style'] });
  });

  whenInitialized.then(() => {
    const strip = thumbsGallery.querySelector('ol.flex-control-thumbs');
    if (!strip) return;

    const makeArrow = (dir, label) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `gallery-thumbs-arrow gallery-thumbs-arrow--${dir}`;
      btn.setAttribute('aria-label', label);
      thumbsGallery.appendChild(btn);
      return btn;
    };

    const up = makeArrow('up', 'Vorige afbeeldingen');
    const down = makeArrow('down', 'Volgende afbeeldingen');

    // Two thumbs (incl. the 10px gap) per click
    const step = () => {
      const thumb = strip.querySelector('li');
      return thumb ? (thumb.offsetHeight + 10) * 2 : 240;
    };

    const update = () => {
      const scrollable = strip.scrollHeight > strip.clientHeight + 1;
      up.classList.toggle('is-hidden', !scrollable || strip.scrollTop <= 0);
      down.classList.toggle(
        'is-hidden',
        !scrollable || strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 1
      );
    };

    up.addEventListener('click', () => strip.scrollBy({ top: -step(), behavior: 'smooth' }));
    down.addEventListener('click', () => strip.scrollBy({ top: step(), behavior: 'smooth' }));
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Thumb heights settle as images stream in
    update();
    setTimeout(update, 600);
    setTimeout(update, 2000);
  });
}
